export default "__VITE_ASSET__356986ab__"